import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/camps/')({
  component: CampsIndex,
});

function CampsIndex() {
  const locale = useStore(langStore, s => s);

  const content = {
    HU: `# Alkotótáborok

A Malomfesztivál egyik legjobb része nem is maga a fesztivàl. Augusztus első hete a művelődésé, tanulásé és alkotásé! Idén olyan fontos témákkal foglalkozunk mint az igazság keresése, társadalmi szerepvállalás, kiállás és tiltakozás.

Idén 2 tábor (színházi- és filozófia-), és egy művésztelep kerül megrendezésre.

A táborok időtartama augusztus 2-6.

Részvételi díj 10 000 dinár, amely tartalmazza a napi 3 étkezést, az oktatók, előadók díját és fedeti a délutáni-esti programok költségeit.

A tábor díjából 5000 dinár előleg a jelentkezéskor fizetendő - az előleg lemondás esetén nem visszatérítendő, de átruházható! A tábor ára nem tartalmazza a Malomfesztivál bérlet árát, ugyanakkor kedvezményes, 2000 dináros fesztiválbérlet megváltására jogosítja fel a résztvevőket.

Maximális létszám táboronként: 20 fő

Korhatár: minimum 16 év

Jelentkezési határidő: Június 30.

Jelentkezz emailben:
[onyaolahdora@gmail.com](mailto:onyaolahdora@gmail.com)`,
    RS: `# Kreativni kampovi

Jedan od najboljih delova Malomfesztivála je zapravo nedelja koja mu prethodi - nedelja posvećena kulturi, učenju i stvaranju! Ove godine bavimo se važnim temama kao što su potraga za istinom, društvena angažovanost, zauzimanje stava i protest.`,
    EN: `# Creative Camps

One of the best parts of Malomfesztivál is actually the week leading up to it - a week dedicated to culture, learning, and creation! This year, we’re exploring important topics such as the search for truth, social engagement, taking a stand, and protest.`,
  };

  return (
    <div className="text-blackish">
      <MarkdownBlock
        renderers={{
          h1: ({ node, ...props }) =>
            <h1 className="mb-4 text-3xl font-bold text-black" {...props}></h1>,
          p: ({ node, ...props }) =>
            <p className="mb-2 text-left" {...props}></p>,
          a: ({ node, ...props }) =>
            <a className="text-orange hover:underline" {...props}></a>,
        }}
      >
        {content[locale]}
      </MarkdownBlock>
    </div>
  );
}
